import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import style from './item-count.module.less';

export const ItemCount = ({ count = 0, className = '' }) => {
  const classes = classnames(style['item-count'], className);

  return <div className={classes}>{count}</div>;
};

ItemCount.propTypes = {
  count: PropTypes.number,
  className: PropTypes.string,
};
